export default function praCompletedAssessmentDirective() {
  return {
    template: require('./completed-assessment.html'),
    scope: {
      assessment: '=',
      hasIncompleteAssessments: '=',
      isNavantaUser: '=',
    },
    controller: 'PRACompletedAssessmentController',
    controllerAs: 'completedAssessmentVM',
    bindToController: true,
    replace: true,
  };
}
